export default "__VITE_ASSET__Cgbjftd8__"